import { useFormatter, useTranslations } from "next-intl";
import { useInstantSearch } from "react-instantsearch";

export default function AlgoliaResultsCount() {
  const t = useTranslations("Products-list");
  const format = useFormatter();
  const {
    results: { nbHits },
  } = useInstantSearch();

  return (
    <div className="text-[#333]/50 dark:text-primary-dustyWhite text-xl my-5">
      {t("articles", { count: format.number(nbHits) })}
    </div>
  );
}
